import { useEffect } from 'react'

import { useSearchParams } from 'react-router-dom'

import { saveReferralCode, saveChannel, reportChannelVisit } from '@/utils/referral'

/**
 * 追踪 URL 中的推荐码和广告渠道并保存。
 *
 * 与 `bitland-next-frontend/components/ReferralTracker.tsx` 逻辑保持一致：
 * - 解析 `?ref=` → 写入 cookie + localStorage
 * - 解析 `?channel=` → 写入 cookie + localStorage，并上报一次访问
 *
 * 挂载位置：`router/index.tsx` 的 `RootLayout` 内，
 * 保证每次路由跳转都能从新的 search 参数中重新捕获。
 */
export function ReferralTracker(): null {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const refCode = searchParams.get('ref')
    if (refCode) {
      saveReferralCode(refCode)
    }

    const channel = searchParams.get('channel')
    if (channel) {
      saveChannel(channel)
      void reportChannelVisit(channel)
    }
  }, [searchParams])

  return null
}

export default ReferralTracker
